
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"30.658","fill":"#61ba00"},"content":"<path d=\"M40 5.987q0 1.032-.723 1.755L17.083 29.936q-.722.722-1.754.722t-1.755-.722L.722 17.084q-.723-.723-.723-1.755t.723-1.755l3.51-3.51q.722-.722 1.754-.722t1.755.723l7.587 7.612L32.258.722Q32.98 0 34.011 0t1.755.722l3.51 3.51q.722.723.722 1.755z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
